export default __webpack_public_path__ + "static/media/css.a2c8da82.svg";